import React, { useEffect, useState, useCallback } from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, ShoppingBag, Users, Activity, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StatCard = ({ icon: Icon, label, value, sub, gradient, testid }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
    className={`relative overflow-hidden rounded-2xl p-5 text-white shadow-md ${gradient}`}
    data-testid={testid}
  >
    <div className="flex items-start justify-between mb-3">
      <Icon className="w-6 h-6 opacity-90" />
    </div>
    <p className="text-white/80 text-xs uppercase tracking-wider">{label}</p>
    <p className="font-playfair text-3xl font-bold mt-1 leading-tight">{value}</p>
    {sub && <p className="text-white/70 text-xs mt-2">{sub}</p>}
  </motion.div>
);

const AdminKpiStrip = ({ token }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/admin/dashboard-stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(res.data);
    } catch (e) { /* silent */ }
    finally { setLoading(false); }
  }, [token]);

  useEffect(() => {
    fetchStats();
    const id = setInterval(fetchStats, 60000);
    return () => clearInterval(id);
  }, [fetchStats]);

  if (loading || !stats) {
    return (
      <div className="bg-white rounded-2xl p-8 mb-6 flex items-center justify-center">
        <Loader2 className="w-5 h-5 animate-spin text-charcoal/40" />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-testid="admin-kpi-strip">
      <StatCard icon={TrendingUp} label="Bugünkü Ciro"
        value={`€${stats.today.revenue.toFixed(2)}`}
        sub={`${stats.today.order_count} sipariş · ort €${stats.today.avg_order.toFixed(2)}`}
        gradient="bg-gradient-to-br from-terracotta to-orange-600"
        testid="kpi-today-revenue" />
      <StatCard icon={ShoppingBag} label="Aktif Siparişler"
        value={stats.active_orders}
        sub="Hazırlanıyor / Yolda"
        gradient="bg-gradient-to-br from-amber-500 to-amber-700"
        testid="kpi-active" />
      <StatCard icon={Users} label="Bu Hafta Müşteri"
        value={stats.week.unique_customers}
        sub={`${stats.week.order_count} toplam sipariş`}
        gradient="bg-gradient-to-br from-basil to-emerald-700"
        testid="kpi-week-customers" />
      <StatCard icon={Activity} label="Haftalık Ciro"
        value={`€${stats.week.revenue.toFixed(2)}`}
        sub="Son 7 gün"
        gradient="bg-gradient-to-br from-charcoal to-stone-700"
        testid="kpi-week-revenue" />
    </div>
  );
};

export default AdminKpiStrip;
